<template>
<div class="filters-categories">
	<div class="filters d-flex justify-center" v-if="filters.length > 0">
		<swiper :options="swiperOption">
			<swiper-slide
				v-for="(item, index) in filters"
				:key="index"
				class="filters-wrapper"
				:style="`width: ${width}%`"
			>
				<div
					:class="[
						'wrapper-item',
						{ 'active-filter': item.active },
					]"
					@click="filterOnClick(item, index)"
				>
					<img
						:src="item.urlImage"
						:alt="item.title"
						class="filters-img">
					<span class="filters-text">{{item.title}}</span>
				</div>
			</swiper-slide>
    	</swiper>
		<div class="wrapper-buttons-filters">
			<div class="swiper-button-prev item-btn btn-left" slot="button-prev">
				<img
					src="/static/img/filters/arrow-left.svg"
					alt="flecha izquierda"
				>
			</div>
    	<div class="swiper-button-next item-btn btn-right" slot="button-next">
				<img
					src="/static/img/filters/arrow-right.svg"
					alt="flecha derecha"
				>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';

function filterOnClick({ link, id }) {
	if (link) {
		window.open(link);
	} else {
		this.$router.push({ name: 'filters', params: { id } });
	}
}

function data() {
	return {
		swiperOption: {
			slidesPerView: 'auto',
			spaceBetween: 30,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				1024: {
					spaceBetween: 10,
				},
			},
		},
	};
}

function width() {
	return this.filters.length > 6 ? 25 : 100 / this.filters.length;
}

export default {
	name: 'Filters',
	data,
	components: {
		swiper,
		swiperSlide,
	},
	computed: {
		width,
	},
	methods: {
		filterOnClick,
	},
	props: {
		filters: {
			default: () => [],
			type: Array,
		},
	},
};

</script>
<style lang="scss">
	.filters {
		padding: 6rem 11%;
		position: relative;

		&-img {
			display: block;
			height: 67%;
			margin: 0 auto 2rem;
			object-fit: contain;
			width: 100%;
		}

		&-name {
			font-size: 1.6rem;
		}

		&-wrapper {
			font-family: font(open-bold);
			font-size: size(normal);
			height: 16.3rem;
			white-space: nowrap;

			&::after {
				background: color(textGrey);
				content: '';
				height: 7.4rem;
				position: absolute;
				right: -1.5rem;
				transform: translateY(-50%);
				top: 50%;
				width: 0.1rem;
			}
		}

		&-text {
			border-bottom: 0.5rem solid transparent;
			left: 50%;
			padding: 0 0.9rem 0.5rem;
			position: absolute;
			transform: translateX(-50%);
			transition: all .4s ease-in-out 0s;
		}

		.wrapper-item {
			cursor: pointer;
			height: 100%;
			padding: 1rem 0;
			width: 100%;

			&.active-filter {
				.filters-text {
					border-bottom: 0.5rem solid color(defaultOrange);
				}
			}
		}

		.wrapper-buttons-filters {
			bottom: 50%;
			height: 3.2rem;
			position: absolute;
			width: 100%;

			.item-btn {
				background: transparent;
				border: none;
				cursor: pointer;
				outline: none;
				position: absolute;
			}

			.btn-right {
				right: 8%;
			}

			.btn-left {
				left: 8%;
			}
		}

		.swiper-button-prev, .swiper-button-next {
			margin-top: 0 !important;
		}

		.swiper-container {
			width: 100%;
		}
	}

	@media screen and (max-width: 1024px) {
		.filters {
			padding: 1rem 0 1rem 0.7rem;

			&-img {
				height: 3.9rem;
			}

			&-wrapper {
				font-size: 1rem;
				height: 8.5rem;

				&::after {
					height: 4.6rem;
				}
			}

			.wrapper-buttons-filters {
				display: none;
			}
		}
	}

	@media screen and (max-width: 450px) {
		.filters-categories {
			display: none;
		}
	}
</style>





// WEBPACK FOOTER //
// Filters.vue?b25cdcd8